import { SIZE_5_MB, SIZE_10_MB } from './uploads';

export enum $screenshot {
  _id = '_id',
  error = 'error',
  regularScreenshot = 'regularScreenshot',
  thumbnailScreenshot = 'thumbnailScreenshot',
  auditedDocument = 'auditedDocument',
  tenantId = 'tenantId',
}

export const SCREENSHOT_MAX_FILE_SIZE: number = SIZE_5_MB;

export const SCREENSHOT_MOBILE_MAX_FILE_SIZE: number = SIZE_10_MB;
